import layout from '@/views/layout/layout.vue'
const supermarketList = r => require.ensure([], () => r(require('@/views/marketing/supermarket/list.vue')), 'group-system-supermarket')

const supermarketConfig = [
  {
    path: '/marketing/supermarket',
    name: 'marketing-supermarket',
    component: layout,
    redirect: '/marketing/supermarket/list',
    hidden: true,
    children: [
      {
        path: 'list',
        component: supermarketList,
        name: 'system-supermarket-list',
        meta: {
          displayName: '终端管理',
          requireAuth: true
        }
      }
    ]
  }
]

export default supermarketConfig



// WEBPACK FOOTER //
// ./src/router/marketing/supermarket.js